module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-flex4.594d914b.png";